import { IComboSlotOption, IItem } from '@rbi-ctg/menu';
import { MenuObjectTypes } from 'enums/menu';

import { ProductHierarchyType } from '../types';

import { DrinkCategoriesKeys, DrinksCategories, DrinksCategorizedOptions } from './types';

export const getItemCategory = (item: IItem): DrinkCategoriesKeys => {
  let category: DrinkCategoriesKeys | undefined = DrinksCategories.OTHERS;

  switch (item.productHierarchy?.L3) {
    case ProductHierarchyType.FROZEN_DRINKS:
      category = DrinksCategories.FROZENS;
      break;
    case ProductHierarchyType.SHAKES:
      category = DrinksCategories.SHAKES;
      break;
    case ProductHierarchyType.SOFT_DRINKS:
      category = DrinksCategories.SOFT_DRINKS;
      break;
    case ProductHierarchyType.JUICES:
      category = DrinksCategories.OTHERS;
      break;
    default:
      category = DrinksCategories.OTHERS;
      break;
  }

  return category;
};

export const categorizeDrinksOptions = (options: IComboSlotOption[]): DrinksCategorizedOptions => {
  const acc: DrinksCategorizedOptions = {
    FROZENS: [],
    SHAKES: [],
    SOFT_DRINKS: [],
    OTHERS: [],
  };

  options.forEach(option => {
    if (option.option._type === MenuObjectTypes.ITEM) {
      const itemCategory = getItemCategory(option.option);

      if (itemCategory) {
        acc[itemCategory].push(option);
      }
    }
  });

  return acc;
};

export const orderedCategories = [
  DrinksCategories.SOFT_DRINKS,
  DrinksCategories.SHAKES,
  DrinksCategories.FROZENS,
  DrinksCategories.OTHERS,
];

// Helper function to ensure tab is a valid DrinkCategoriesKeys
export const getValidTabKey = (tab: string): string => {
  if (Object.values(DrinksCategories).includes(tab as DrinksCategories)) {
    return tab.toString();
  }

  // Fallback
  return DrinksCategories.SOFT_DRINKS.toString();
};
